import { __assign, __awaiter, __generator } from "tslib";
// @ts-ignore
import { AuthTypeEnum, DUMMY_BASE_URL, setSearchParams } from '@redhat-cloud-services/javascript-clients-shared/dist/common';
/**
  * @export
  * @enum {string}
  */
export var ApiTagGetTagsOrderByEnum = {
    Tag: 'tag',
    Count: 'count'
};
/**
  * @export
  * @enum {string}
  */
export var ApiTagGetTagsStalenessEnum = {
    Fresh: 'fresh',
    Stale: 'stale',
    StaleWarning: 'stale_warning',
    Unknown: 'unknown'
};
/**
  * @export
  * @enum {string}
  */
export var ApiTagGetTagsProviderTypeEnum = {
    Alibaba: 'alibaba',
    Aws: 'aws',
    Azure: 'azure',
    Discovery: 'discovery',
    Gcp: 'gcp',
    Ibm: 'ibm'
};
/**
  * @export
  * @enum {string}
  */
export var ApiTagGetTagsRegisteredWithEnum = {
    Insights: 'insights',
    Yupana: 'yupana',
    Satellite: 'satellite',
    Discovery: 'discovery',
    Puptoo: 'puptoo',
    RhsmConduit: 'rhsm-conduit',
    CloudConnector: 'cloud-connector',
    NotYupana: '!yupana',
    NotSatellite: '!satellite',
    NotDiscovery: '!discovery',
    NotPuptoo: '!puptoo',
    NotRhsmConduit: '!rhsm-conduit',
    NotCloudConnector: '!cloud-connector'
};
/**
  * @export
  * @enum {string}
  */
export var ApiTagGetTagsSystemTypeEnum = {
    Conventional: 'conventional',
    Bootc: 'bootc',
    Edge: 'edge',
    Cluster: 'cluster'
};
var isApiTagGetTagsObjectParams = function (params) {
    var l = params.length === 1;
    if (l && typeof params[0] === 'object' && !Array.isArray(params[0])) {
        return true;
    }
    return false;
};
/**
* Required permissions: inventory:hosts:read
* @summary Get the active host tags for a given account
* @param {ApiTagGetTagsParams} config with all available params.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export var apiTagGetTagsParamCreator = function (sendRequest) {
    var config = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        config[_i - 1] = arguments[_i];
    }
    return __awaiter(void 0, void 0, void 0, function () {
        var params, tags, orderBy, orderHow, perPage, page, staleness, search, displayName, fqdn, hostnameOrId, insightsId, providerId, providerType, updatedStart, updatedEnd, lastCheckInStart, lastCheckInEnd, groupName, registeredWith, systemType, filter, _a, options, localVarPath, localVarUrlObj, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, args;
        return __generator(this, function (_b) {
            params = isApiTagGetTagsObjectParams(config) ? config[0] : ['tags', 'orderBy', 'orderHow', 'perPage', 'page', 'staleness', 'search', 'displayName', 'fqdn', 'hostnameOrId', 'insightsId', 'providerId', 'providerType', 'updatedStart', 'updatedEnd', 'lastCheckInStart', 'lastCheckInEnd', 'groupName', 'registeredWith', 'systemType', 'filter', 'options'].reduce(function (acc, curr, index) {
                var _a;
                return (__assign(__assign({}, acc), (_a = {}, _a[curr] = config[index], _a)));
            }, {});
            tags = params.tags, orderBy = params.orderBy, orderHow = params.orderHow, perPage = params.perPage, page = params.page, staleness = params.staleness, search = params.search, displayName = params.displayName, fqdn = params.fqdn, hostnameOrId = params.hostnameOrId, insightsId = params.insightsId, providerId = params.providerId, providerType = params.providerType, updatedStart = params.updatedStart, updatedEnd = params.updatedEnd, lastCheckInStart = params.lastCheckInStart, lastCheckInEnd = params.lastCheckInEnd, groupName = params.groupName, registeredWith = params.registeredWith, systemType = params.systemType, filter = params.filter, _a = params.options, options = _a === void 0 ? {} : _a;
            localVarPath = "/tags";
            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            localVarRequestOptions = __assign({ method: 'GET' }, options);
            localVarHeaderParameter = {};
            localVarQueryParameter = {};
            if (tags) {
                localVarQueryParameter['tags'] = tags;
            }
            if (orderBy !== undefined) {
                localVarQueryParameter['order_by'] = orderBy;
            }
            if (orderHow !== undefined) {
                localVarQueryParameter['order_how'] = orderHow;
            }
            if (perPage !== undefined) {
                localVarQueryParameter['per_page'] = perPage;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (staleness) {
                localVarQueryParameter['staleness'] = staleness;
            }
            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }
            if (displayName !== undefined) {
                localVarQueryParameter['display_name'] = displayName;
            }
            if (fqdn !== undefined) {
                localVarQueryParameter['fqdn'] = fqdn;
            }
            if (hostnameOrId !== undefined) {
                localVarQueryParameter['hostname_or_id'] = hostnameOrId;
            }
            if (insightsId !== undefined) {
                localVarQueryParameter['insights_id'] = insightsId;
            }
            if (providerId !== undefined) {
                localVarQueryParameter['provider_id'] = providerId;
            }
            if (providerType !== undefined) {
                localVarQueryParameter['provider_type'] = providerType;
            }
            if (updatedStart !== undefined) {
                localVarQueryParameter['updated_start'] = (updatedStart instanceof Date) ?
                    updatedStart.toISOString() :
                    updatedStart;
            }
            if (updatedEnd !== undefined) {
                localVarQueryParameter['updated_end'] = (updatedEnd instanceof Date) ?
                    updatedEnd.toISOString() :
                    updatedEnd;
            }
            if (lastCheckInStart !== undefined) {
                localVarQueryParameter['last_check_in_start'] = (lastCheckInStart instanceof Date) ?
                    lastCheckInStart.toISOString() :
                    lastCheckInStart;
            }
            if (lastCheckInEnd !== undefined) {
                localVarQueryParameter['last_check_in_end'] = (lastCheckInEnd instanceof Date) ?
                    lastCheckInEnd.toISOString() :
                    lastCheckInEnd;
            }
            if (groupName) {
                localVarQueryParameter['group_name'] = groupName;
            }
            if (registeredWith) {
                localVarQueryParameter['registered_with'] = registeredWith;
            }
            if (systemType) {
                localVarQueryParameter['system_type'] = systemType;
            }
            if (filter !== undefined) {
                localVarQueryParameter['filter'] = filter;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
            args = {
                urlObj: localVarUrlObj,
                options: localVarRequestOptions,
                auth: [
                    {
                        // authentication ApiKeyAuth required
                        // in header with key required
                        authType: AuthTypeEnum.InHeader,
                        authKey: "x-rh-identity"
                    }
                ]
            };
            return [2 /*return*/, sendRequest(Promise.resolve(args))];
        });
    });
};
export default apiTagGetTagsParamCreator;
//# sourceMappingURL=index.js.map